<script setup lang="ts">
import Cms from "@/components/Cms.vue";
import { ref, computed } from "vue";
// import { registeredComponents } from "@root/cms-page-init.ts";
import { getBuilderComponents } from "@root/builder-components.ts";
import { Head } from "@inertiajs/vue3";
let props = defineProps({
    pageName: {
        type: String,
        default: ""
    },
    cmsContent: {
        type: Object,
        default: () => ({
            data: {
                pageName: null,
                metaDescription: "",
                metaKeywords: ""
            }
        })
    }   
})



let searchParams = computed(()=>{
    return {
        "data.pageUrl.$eq": props.pageName
    }
})


let builderData = ref({
    pageName: null,
    metaDescription: "",
    metaKeywords: ""
})

let pageName = computed(()=>{
    return props.cmsContent?.data?.pageName ?? builderData.value?.pageName;
})

let metaDescription = computed(()=>{
    return props.cmsContent?.data?.metaDescription ?? builderData.value?.metaDescription;
})
let metaKeywords = computed(()=>{
    return props.cmsContent?.data?.metaKeywords ?? builderData.value?.metaKeywords;
})
</script>
<template>
    <div>
        <Head>
            <title>{{ pageName }}</title>
            <meta name="description" :content="metaDescription" />
            <meta name="keywords" :content="metaKeywords" />
        </Head>
        <cms v-model="builderData" contentProp="cmsContent" :readable-fields="['metaDescription', 'metaKeywords','pageName']" model="content-section" driver="builder" :components="getBuilderComponents()" is-section :search-params="searchParams"/>
    </div>
</template>